import apiService from "./apiService";

const reportService = {
    async getUnspecified(id) {
        try {
            const response = await apiService.get(`reports/get-unspecified/${id}`,{}, true);
            return response.data || [];  // Return empty array if data is null/undefined
        } catch (error) {
            console.error('Error fetching unspecified voters:', error);
            return [{ id: 0, cityname: "Error fetching data" }];  // More descriptive fallback
        }
    },

    async getBrgySummary(id) {
        try {
            const response = await apiService.get(`reports/get-brgy-summary/${id}`,{}, true);
            return response.data || [];  // Return empty array if data is null/undefined
        } catch (error) {
            console.error('Error fetching unspecified voters:', error);
            return [{ id: 0, cityname: "Error fetching data" }];  // More descriptive fallback
        }
    }
    

};

export default reportService;